import { HttpMethod, HttpModel } from '@/Shared/domain'
import { axiosFetch } from '@/Shared/infrastructure'
import { 
  getHelpCenterCaseReasons,
  getHelpCenterCaseProducts,
  saveHelpCenterCase
 } from '@/Shared/infrastructure/endpoints'
import { HelpCenterRepository } from '../domain/HelpCenterRepository'
import { 
  TicketModel,
  CaseProduct,
  SaveCaseRequest
} from '../domain'

export function createHelpCenterRepository(): HelpCenterRepository {
  return new ApiHelpCenterRepository()
}

export class ApiHelpCenterRepository implements HelpCenterRepository {
  async GetCaseReasons(): Promise<HttpModel<TicketModel[]>> {
    const response = await axiosFetch(getHelpCenterCaseReasons, HttpMethod.GET)

    if (!response.data) {
      return {
        data: [] as TicketModel[],
        meta: response.meta,
      }
    }

    return {
      data: response.data,
      meta: response.meta,
    }
  }
  async GetCaseProducts(): Promise<HttpModel<CaseProduct[]>> {
    const response = await axiosFetch(getHelpCenterCaseProducts, HttpMethod.GET)

    if (!response.data) {
      return {
        data: [] as CaseProduct[],
        meta: response.meta,
      }
    }

    return {
      data: response.data,
      meta: response.meta,
    } 
  }

  async SaveCaseRequest(data: SaveCaseRequest): Promise<HttpModel<boolean>> {
    const response = await axiosFetch(saveHelpCenterCase, HttpMethod.POST, data)

    return {
      data: response.data ?? false,
      meta: response.meta,
    }
  }
  
}
